<i18n>
{
  "fr": {},
  "en": {}
}
</i18n>

<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <charter />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Transition1point5WrapperCharter',
  components: {
    charter: () => import('@/components/transition/docs/Charter.vue')
  }
}
</script>
